<template>
  <div class="alumni-card-box">
    <div class="card-top">
      <div class="alumni-img-box" @click="goDetail">
        <img :src="info.url" alt="item.aName">
      </div>
      <div class="alumni-info">
        <div class="alumni-name">{{ info.name }}</div>
        <div class="alumni-otherInfo">{{ info.college }}<span v-if="info.amajor">/{{ info.amajor }}</span> <span v-if="info.aXuejie">{{ info.aXuejie }}届</span></div>
      </div>
      <div class="open" @click.stop="openCard">
        <van-icon :name="isOpen ? 'arrow-up' : 'arrow-down'" size="20px" color="#747474" />
      </div>
    </div>
    <div v-if="isOpen" class="card-bottom">
      <div class="info-detail">
        <van-icon name="location-o" size="15px" color="#333333" />
        <span>{{ info.aprovince }}-{{ info.city }}</span>
      </div>
      <div class="info-detail">
        <van-icon name="phone-o" size="15px" color="#333333" />
        <span>{{ info.isExchange ? info.phone : phone_hide(info.phone) }}</span>
      </div>
      <div class="go-detail" @click="goDetail">查看详情</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myAluminAssembly",
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  mounted() {
  },
  created() {

  },
  methods: {
    phone_hide(phone) {
      if (phone && phone.length === 11) {
        phone = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return phone
    },
    openCard() {
      this.isOpen = !this.isOpen
    },
    goDetail() {
      this.$emit('go', this.info.userId)
    }
  }
}
</script>

<style lang="less" scoped>
.alumni-card-box {
  padding: 0 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  border: 1px solid #f3f3f3;
  background-color: #ffffff;
  .card-top {
    position: relative;
    padding: 15px 0;
    display: flex;
    align-items: center;
    .open {
      position: absolute;
      bottom: 15px;
      right: 0;
      width: 20px;
      height: 20px;
    }
    .alumni-img-box {
      width: 60px;
      height: 60px;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        // object-fit: cover;
        background-size: 100% 100%;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
      }
      .sex {
        width: 15px;
        height: 15px;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        position: absolute;
        margin-top: -3px;
        margin-left: -15px;
      }
    }
    .alumni-info {
      margin-left: 15px;
      .alumni-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 1rem;
        // border: 1px solid #888;
        color: #333333;
        font-weight: bold;
      }
      .alumni-name-img {
        position: relative;
        // width: 13px;
        // height: 16px;
        padding-top: 0px;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        margin-left: 20px;
      }
      .alumni-name-div-o {
        font-weight: 500;
        font-size: 0.8rem;
        margin-left: 5px;
      }
      .alumni-name-div-t {
        color: #248381;
        font-weight: 500;
        font-size: 0.8rem;
        margin-left: 5px;
        position: absolute;
        right: 5px;
      }
      .alumni-otherInfo {
        overflow: hidden;
        min-height: 17px;
        color: #757575;
        margin-top: 5px;
        font-size: 0.9rem;
      }
    }
  }
  .card-bottom {
    padding: 15px 0;
    border-top: 1px solid #f3f3f3;
    color: #333333;
    .info-detail {
      margin-bottom: 10px;
    }
    span {
      margin-left: 5px;
      color: #333333;
      font-size: 0.9rem;
    }
    .go-detail {
      text-align: center;
      font-weight: bold;
      color: #666666;
      font-size: 0.95rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniResources/components/AlumniInfoCard/myAluminAssembly.vue